import treePhase4Img from '~/assets/plant/4.png'
import treePhase5Img from '~/assets/plant/5.png'
import treePhase6Img from '~/assets/plant/6.png'
import treePhase7Img from '~/assets/plant/7.png'
import productImg from '~/assets/plant/product.png'

import { Dialog, DialogContent } from '~/components/ui/dialog'
import { m } from '~/paraglide/messages'

export function PlantDialog(props: { isOpen: boolean; close: () => void }) {
  return (
    <Dialog
      open={props.isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          props.close()
        }
      }}
    >
      <DialogContent class="w-[calc(100vw-48px)] max-w-[285px] rounded-lg bg-white p-[10px] text-center text-[#333333]">
        <div class="relative overflow-hidden rounded-lg">
          <div class="h-[145px] bg-[#FCF0BE]" />
          <div class="h-[29px] bg-[#874E07]" />
          <div class="h-[26px] bg-[#6F4000]" />
          <div class="absolute inset-0 grid place-items-center rounded-lg shadow-[0_0_4px_0_rgba(0,0,0,0.2)_inset]">
            <img class="size-[159px]" src={productImg} alt="item" />
          </div>
        </div>
        <div class="mt-3 space-y-1 px-[6px] text-center">
          <h2 class="text-lg font-medium">{m.tree_type_163_title()}</h2>
          <p class="flex min-h-20 items-center text-sm text-[#666666]">
            {m.tree_type_163_description()}
          </p>
          <div class="flex justify-between">
            <div>
              <img class="size-[55px]" src={treePhase4Img} alt="tree-phase-4" />
              <span class="mt-[3px] text-center text-sm text-[#51A387]">
                10-55
              </span>
            </div>
            <div>
              <img class="size-[55px]" src={treePhase5Img} alt="tree-phase-5" />
              <span class="mt-[3px] text-center text-sm text-[#51A387]">
                60
              </span>
            </div>
            <div>
              <img class="size-[55px]" src={treePhase6Img} alt="tree-phase-6" />
              <span class="mt-[3px] text-center text-sm text-[#51A387]">
                90
              </span>
            </div>
            <div>
              <img class="size-[55px]" src={treePhase7Img} alt="tree-phase-7" />
              <span class="mt-[3px] text-center text-sm text-[#51A387]">
                120 mins
              </span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
